import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmAi = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="none" className="icon-llm-ai" data-icon="icon-llm-ai" aria-hidden="true" {...props} ref={ref}><rect x="7" width="2" height="2" fill="currentColor"/><rect y="7" width="2" height="2" fill="currentColor"/><rect x="7" y="7" width="2" height="2" fill="currentColor"/><rect x="7" y="14" width="2" height="2" fill="currentColor"/><rect x="14" y="7" width="2" height="2" fill="currentColor"/></svg>);
});

IconLlmAi.displayName = 'IconLlmAi';
